// Theme types
export interface Theme {
  mode: 'light' | 'dark' | 'system';
  primary: string;
  secondary: string;
  accent: string;
}

// Status types
export enum StatusType {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  WARNING = 'warning',
  ERROR = 'error',
  RESOLVED = 'resolved',
  INVESTIGATING = 'investigating',
  RUNNING = 'running',
  SUCCESS = 'success',
  NEUTRAL = 'neutral'
}

// Shared UI context type
export interface SharedUIContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  showTooltip: (content: string, x: number, y: number) => void;
  hideTooltip: () => void;
  tooltipContent: string;
  tooltipPosition: { x: number; y: number };
  isModalOpen: boolean;
  setIsModalOpen: (open: boolean) => void;
}

// Modal context type
export interface ModalContextType {
  isModalOpen: boolean;
  setIsModalOpen: (open: boolean) => void;
  theme: Theme;
}

// Alert tag type
export interface AlertTag {
  id: string;
  name: string;
  color: string;
}

// Alert details type
export interface AlertDetails {
  source: string;
  affectedHost: string;
  technique: string;
  confidence: number;
  description: string;
}

// Alert type
export interface Alert {
  id: string;
  title: string;
  severity: string;
  status: StatusType;
  timestamp: string;
  description: string;
  affectedAsset: string;
  assignedTo: string;
  tags: AlertTag[];
  details: AlertDetails;
}

// Threat feed type
export interface ThreatFeed {
  id: string;
  name: string;
  type: string;
  provider: string;
  feed_type: string | null;
  lastUpdate: string;
  last_sync_at: string | null;
  last_error?: string | null;
  status: StatusType;
  indicators: number;
  indicators_count: number;
  error_count: number;
  polling_interval_minutes: number;
  created_at: string;
  updated_at: string;
  config: {
    mode?: 'shared' | 'custom';
    auto_enabled?: boolean;
    description?: string;
    [key: string]: any;
  } | null;
}

// Threat intel state type
export interface ThreatIntelState {
  feeds: ThreatFeed[];
  loading: boolean;
  error: Error | null;
}
